var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-locale-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('PageHeader'),_c('router-view'),_c('PageFooters')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }